var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content bottom-nav-container" }, [
    _c("div", { staticClass: "external-gdpr-container" }, [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.gdprText) } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }